/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          EM Service User API
Version:      1
Description:  Event Management Service User API provides all the user related calls
Generated at: 05/12/2024 15:51 (GMT Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from '../Providers.Api/ApiError';
import { ODataSelect } from '../Providers.Api/ODataQuery';
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from '../Providers.Api/Models';
import { ApiHelper } from '../Providers.Api/ApiHelper';
import { IbssRequestConfig } from '../Providers.Api/ApiClient';

export interface IContext
{
    baseUrl: string;
}

export interface IEmServiceUserApiClientV1
{
    v1: IEmServiceUserApiClientV1_V1;
    api: IEmServiceUserApiClientV1_Api;


}

export class EmServiceUserApiClientV1 implements IEmServiceUserApiClientV1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v1 = new EmServiceUserApiClientV1_V1(context);
        this.api = new EmServiceUserApiClientV1_Api(context);
    }

    public v1: EmServiceUserApiClientV1_V1;
    public api: EmServiceUserApiClientV1_Api;


}

export interface IEmServiceUserApiClientV1_V1
{
    service: IEmServiceUserApiClientV1_V1_Service;


}

export class EmServiceUserApiClientV1_V1 implements IEmServiceUserApiClientV1_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.service = new EmServiceUserApiClientV1_V1_Service(context);
    }

    public service: EmServiceUserApiClientV1_V1_Service;


}

export interface IEmServiceUserApiClientV1_V1_Service
{
    heartbeat: IEmServiceUserApiClientV1_V1_Service_Heartbeat;
    version: IEmServiceUserApiClientV1_V1_Service_Version;


}

export class EmServiceUserApiClientV1_V1_Service implements IEmServiceUserApiClientV1_V1_Service
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.heartbeat = new EmServiceUserApiClientV1_V1_Service_Heartbeat(context);
        this.version = new EmServiceUserApiClientV1_V1_Service_Version(context);
    }

    public heartbeat: EmServiceUserApiClientV1_V1_Service_Heartbeat;
    public version: EmServiceUserApiClientV1_V1_Service_Version;


}

export interface IEmServiceUserApiClientV1_V1_Service_Heartbeat
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_V1_Service_Heartbeat implements IEmServiceUserApiClientV1_V1_Service_Heartbeat
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/heartbeat?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_V1_Service_Version
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_V1_Service_Version implements IEmServiceUserApiClientV1_V1_Service_Version
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/version?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api
{
    user: IEmServiceUserApiClientV1_Api_User;


}

export class EmServiceUserApiClientV1_Api implements IEmServiceUserApiClientV1_Api
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.user = new EmServiceUserApiClientV1_Api_User(context);
    }

    public user: EmServiceUserApiClientV1_Api_User;


}

export interface IEmServiceUserApiClientV1_Api_User
{
    v1: IEmServiceUserApiClientV1_Api_User_V1;


}

export class EmServiceUserApiClientV1_Api_User implements IEmServiceUserApiClientV1_Api_User
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v1 = new EmServiceUserApiClientV1_Api_User_V1(context);
    }

    public v1: EmServiceUserApiClientV1_Api_User_V1;


}

export interface IEmServiceUserApiClientV1_Api_User_V1
{
    delegates: IEmServiceUserApiClientV1_Api_User_V1_Delegates;
    roles: IEmServiceUserApiClientV1_Api_User_V1_Roles;
    users: IEmServiceUserApiClientV1_Api_User_V1_Users;


}

export class EmServiceUserApiClientV1_Api_User_V1 implements IEmServiceUserApiClientV1_Api_User_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.delegates = new EmServiceUserApiClientV1_Api_User_V1_Delegates(context);
        this.roles = new EmServiceUserApiClientV1_Api_User_V1_Roles(context);
        this.users = new EmServiceUserApiClientV1_Api_User_V1_Users(context);
    }

    public delegates: EmServiceUserApiClientV1_Api_User_V1_Delegates;
    public roles: EmServiceUserApiClientV1_Api_User_V1_Roles;
    public users: EmServiceUserApiClientV1_Api_User_V1_Users;


}

export interface IEmServiceUserApiClientV1_Api_User_V1_Delegates
{
    myDelegates: IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates;
    myPrimaries: IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries;
    byId: IEmServiceUserApiClientV1_Api_User_V1_Delegates_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IDelegateRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Delegates implements IEmServiceUserApiClientV1_Api_User_V1_Delegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.myDelegates = new EmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates(context);
        this.myPrimaries = new EmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries(context);
        this.byId = new EmServiceUserApiClientV1_Api_User_V1_Delegates_ById(context);
    }

    public myDelegates: EmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates;
    public myPrimaries: EmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries;
    public byId: EmServiceUserApiClientV1_Api_User_V1_Delegates_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Delegates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IDelegateRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Delegates?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/user/v1/Delegates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates implements IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyDelegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Delegates/my-delegates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries implements IEmServiceUserApiClientV1_Api_User_V1_Delegates_MyPrimaries
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Delegates/my-primaries?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Delegates_ById
{

    get<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { id: string, body: IDelegateRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Delegates_ById implements IEmServiceUserApiClientV1_Api_User_V1_Delegates_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Delegates/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: string, body: IDelegateRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/user/v1/Delegates/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/user/v1/Delegates/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Roles
{
    byName: IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Roles implements IEmServiceUserApiClientV1_Api_User_V1_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byName = new EmServiceUserApiClientV1_Api_User_V1_Roles_ByName(context);
    }

    public byName: EmServiceUserApiClientV1_Api_User_V1_Roles_ByName;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName
{
    users: IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users;

    get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Roles_ByName implements IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.users = new EmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users(context);
    }

    public users: EmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users;


    public async get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Roles/${options.name}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users
{

    get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users implements IEmServiceUserApiClientV1_Api_User_V1_Roles_ByName_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { name: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Roles/${options.name}/users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users
{
    byPartialEmail: IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail;
    deleted: IEmServiceUserApiClientV1_Api_User_V1_Users_Deleted;
    byPartialUserName: IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName;
    authenticate: IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate;
    authenticate2: IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2;
    resetpassword: IEmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword;
    roles: IEmServiceUserApiClientV1_Api_User_V1_Users_Roles;
    userroles: IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles;
    userroles2: IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles2;
    userdetails: IEmServiceUserApiClientV1_Api_User_V1_Users_Userdetails;
    userpreferences: IEmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences;
    userapplicationactions: IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions;
    userapplicationactions2: IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2;
    usercanlock: IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock;
    usercanunlock: IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock;
    rightsforusernameandevent: IEmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent;
    allavailableowners: IEmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners;
    protected: IEmServiceUserApiClientV1_Api_User_V1_Users_Protected;
    syncaad: IEmServiceUserApiClientV1_Api_User_V1_Users_Syncaad;
    byUsername: IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername;
    identityproviders: IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders;
    identityproviders2: IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2;
    optoutsettings: IEmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings;
    allexternalidentityproviders: IEmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders;

    get<TResponse>(options: { statusCode?: HttpStatusCode, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users implements IEmServiceUserApiClientV1_Api_User_V1_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byPartialEmail = new EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail(context);
        this.deleted = new EmServiceUserApiClientV1_Api_User_V1_Users_Deleted(context);
        this.byPartialUserName = new EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName(context);
        this.authenticate = new EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate(context);
        this.authenticate2 = new EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2(context);
        this.resetpassword = new EmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword(context);
        this.roles = new EmServiceUserApiClientV1_Api_User_V1_Users_Roles(context);
        this.userroles = new EmServiceUserApiClientV1_Api_User_V1_Users_Userroles(context);
        this.userroles2 = new EmServiceUserApiClientV1_Api_User_V1_Users_Userroles2(context);
        this.userdetails = new EmServiceUserApiClientV1_Api_User_V1_Users_Userdetails(context);
        this.userpreferences = new EmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences(context);
        this.userapplicationactions = new EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions(context);
        this.userapplicationactions2 = new EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2(context);
        this.usercanlock = new EmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock(context);
        this.usercanunlock = new EmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock(context);
        this.rightsforusernameandevent = new EmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent(context);
        this.allavailableowners = new EmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners(context);
        this.protected = new EmServiceUserApiClientV1_Api_User_V1_Users_Protected(context);
        this.syncaad = new EmServiceUserApiClientV1_Api_User_V1_Users_Syncaad(context);
        this.byUsername = new EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername(context);
        this.identityproviders = new EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders(context);
        this.identityproviders2 = new EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2(context);
        this.optoutsettings = new EmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings(context);
        this.allexternalidentityproviders = new EmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders(context);
    }

    public byPartialEmail: EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail;
    public deleted: EmServiceUserApiClientV1_Api_User_V1_Users_Deleted;
    public byPartialUserName: EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName;
    public authenticate: EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate;
    public authenticate2: EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2;
    public resetpassword: EmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword;
    public roles: EmServiceUserApiClientV1_Api_User_V1_Users_Roles;
    public userroles: EmServiceUserApiClientV1_Api_User_V1_Users_Userroles;
    public userroles2: EmServiceUserApiClientV1_Api_User_V1_Users_Userroles2;
    public userdetails: EmServiceUserApiClientV1_Api_User_V1_Users_Userdetails;
    public userpreferences: EmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences;
    public userapplicationactions: EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions;
    public userapplicationactions2: EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2;
    public usercanlock: EmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock;
    public usercanunlock: EmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock;
    public rightsforusernameandevent: EmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent;
    public allavailableowners: EmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners;
    public protected: EmServiceUserApiClientV1_Api_User_V1_Users_Protected;
    public syncaad: EmServiceUserApiClientV1_Api_User_V1_Users_Syncaad;
    public byUsername: EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername;
    public identityproviders: EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders;
    public identityproviders2: EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2;
    public optoutsettings: EmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings;
    public allexternalidentityproviders: EmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders;


    public async get<TResponse>(options: { statusCode?: HttpStatusCode, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.statusCode) { queryParts.push(`statusCode=${encodeURIComponent(options.statusCode)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail
{
    getUsers: IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers;


}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.getUsers = new EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers(context);
    }

    public getUsers: EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers;


}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers
{

    get<TResponse>(options: { top?: number, partialEmail: string, includeDeleted?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialEmail_GetUsers
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { top?: number, partialEmail: string, includeDeleted?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.includeDeleted) { queryParts.push(`includeDeleted=${encodeURIComponent(options.includeDeleted)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/${options.partialEmail}/getUsers?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Deleted
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Deleted implements IEmServiceUserApiClientV1_Api_User_V1_Users_Deleted
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/deleted?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName
{
    getUsersbyusername: IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername;


}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.getUsersbyusername = new EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername(context);
    }

    public getUsersbyusername: EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername;


}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername
{

    get<TResponse>(options: { top?: number, partialEmail?: string, includeDeleted?: boolean, partialUserName: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByPartialUserName_GetUsersbyusername
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { top?: number, partialEmail?: string, includeDeleted?: boolean, partialUserName: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.partialEmail) { queryParts.push(`partialEmail=${encodeURIComponent(options.partialEmail)}`);}
            if (options.includeDeleted) { queryParts.push(`includeDeleted=${encodeURIComponent(options.includeDeleted)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/${options.partialUserName}/getUsersbyusername?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate
{

    post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate implements IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/authenticate?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2
{

    post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2 implements IEmServiceUserApiClientV1_Api_User_V1_Users_Authenticate2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/authenticate2?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword
{

    post<TResponse>(options: { body: IUserResetCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword implements IEmServiceUserApiClientV1_Api_User_V1_Users_Resetpassword
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IUserResetCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/resetpassword?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Roles
{

    get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Roles implements IEmServiceUserApiClientV1_Api_User_V1_Users_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userroles implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userroles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles2
{

    get<TResponse>(options: { select: new() => ODataSelect, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userroles2 implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userroles2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userroles2?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userdetails
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userdetails implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userdetails
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userdetails?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences
{

    get<TResponse>(options: { appName?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { pin?: string, pinUpdate?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userpreferences
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { appName?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.appName) { queryParts.push(`appName=${encodeURIComponent(options.appName)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userpreferences?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { pin?: string, pinUpdate?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.pin) { queryParts.push(`pin=${encodeURIComponent(options.pin)}`);}
            if (options.pinUpdate) { queryParts.push(`pinUpdate=${encodeURIComponent(options.pinUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/user/v1/Users/userpreferences?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userapplicationactions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2
{

    get<TResponse>(options: { application?: string, primary?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2 implements IEmServiceUserApiClientV1_Api_User_V1_Users_Userapplicationactions2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { application?: string, primary?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.application) { queryParts.push(`application=${encodeURIComponent(options.application)}`);}
            if (options.primary) { queryParts.push(`primary=${encodeURIComponent(options.primary)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/userapplicationactions2?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock
{

    get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock implements IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanlock
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/usercanlock?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock
{

    get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock implements IEmServiceUserApiClientV1_Api_User_V1_Users_Usercanunlock
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/usercanunlock?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent
{

    get<TResponse>(options: { nodeId?: number, name?: string, eventId?: string, eventOwner?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent implements IEmServiceUserApiClientV1_Api_User_V1_Users_Rightsforusernameandevent
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId?: number, name?: string, eventId?: string, eventOwner?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeId=${encodeURIComponent(options.nodeId)}`);}
            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}
            if (options.eventId) { queryParts.push(`eventId=${encodeURIComponent(options.eventId)}`);}
            if (options.eventOwner) { queryParts.push(`eventOwner=${encodeURIComponent(options.eventOwner)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/rightsforusernameandevent?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners
{

    get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners implements IEmServiceUserApiClientV1_Api_User_V1_Users_Allavailableowners
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/allavailableowners?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Protected
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Protected implements IEmServiceUserApiClientV1_Api_User_V1_Users_Protected
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/protected?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Syncaad
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Syncaad implements IEmServiceUserApiClientV1_Api_User_V1_Users_Syncaad
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/syncaad?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername
{
    identityproviders: IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders;
    identityproviders2: IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2;
    location: IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location;


}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.identityproviders = new EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders(context);
        this.identityproviders2 = new EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2(context);
        this.location = new EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location(context);
    }

    public identityproviders: EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders;
    public identityproviders2: EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2;
    public location: EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location;


}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders
{

    get<TResponse>(options: { username: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { username: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/${options.username}/identityproviders?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders
{

    post<TResponse>(options: { debug?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders implements IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { debug?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/identityproviders?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2
{

    get<TResponse>(options: { username: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2 implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Identityproviders2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { username: string, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/${options.username}/identityproviders2?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2
{

    post<TResponse>(options: { debug?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2 implements IEmServiceUserApiClientV1_Api_User_V1_Users_Identityproviders2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { debug?: boolean, body: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/identityproviders2?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings
{

    post<TResponse>(options: { body: IOptOutSettings, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings implements IEmServiceUserApiClientV1_Api_User_V1_Users_Optoutsettings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IOptOutSettings, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/user/v1/Users/optoutsettings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders implements IEmServiceUserApiClientV1_Api_User_V1_Users_Allexternalidentityproviders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/allexternalidentityproviders?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location
{

    get<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { username: string, body: IUserLocationRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location implements IEmServiceUserApiClientV1_Api_User_V1_Users_ByUsername_Location
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/user/v1/Users/${options.username}/location?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { username: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/user/v1/Users/${options.username}/location?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { username: string, body: IUserLocationRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/user/v1/Users/${options.username}/location?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IDelegateRequest
{
    primaryUser_Id?: string | null;
    primaryUserName?: string | null;
    primaryEmail?: string | null;
    primaryOID?: string | null;
    delegateUser_Id?: string | null;
    delegateUserName?: string | null;
    delegateEmail?: string | null;
    delegateOID?: string | null;
    scope?: number;

}

export type HttpStatusCode = 100 | 101 | 102 | 103 | 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207 | 208 | 226 | 300 | 300 | 301 | 301 | 302 | 302 | 303 | 303 | 304 | 305 | 306 | 307 | 307 | 308 | 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 421 | 422 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451 | 500 | 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;

export interface IUserCredentials
{
    email?: string | null;
    password?: string | null;

}

export interface IUserResetCredentials
{
    email?: string | null;
    oldPassword?: string | null;
    newPassword?: string | null;

}

export interface IOptOutSettings
{
    username?: string | null;
    notificationArea?: NotificationAreaEnum;
    bitmaskedValue?: number;

}

export type NotificationAreaEnum = 0 | 1 | 2 | 3;

export interface IUserLocationRequestModel
{
    location?: string | null;

}
